import { render, staticRenderFns } from "./Fichas.vue?vue&type=template&id=b250b12e&"
import script from "./Fichas.vue?vue&type=script&lang=js&"
export * from "./Fichas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports